import React from "react";
import "./style.css";
import ReceiptIcon from '@mui/icons-material/ReceiptOutlined';
import Grid from '@mui/material/Grid';
import { useNavigate } from "react-router-dom";
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import HandshakeIcon from '@mui/icons-material/Handshake';
import NotListedLocationIcon from '@mui/icons-material/NotListedLocation';
import PaidIcon from '@mui/icons-material/Paid';
import VerifiedIcon from '@mui/icons-material/Verified';
import FmdBadIcon from '@mui/icons-material/FmdBad';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import EmailIcon from '@mui/icons-material/Email';
import BusinessIcon from '@mui/icons-material/Business';
import { useSelector } from 'react-redux';
import HomeIcon from '@mui/icons-material/Home';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import Typography from '@mui/material/Typography';
import PersonAdd from '@mui/icons-material/PersonAdd';
import Settings from '@mui/icons-material/Settings';
import Logout from '@mui/icons-material/Logout';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import {useDispatch} from "react-redux";
import Cookies from "js-cookie";
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import CallIcon from '@mui/icons-material/Call';
import AddIcCallIcon from '@mui/icons-material/AddIcCall';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
export default function LeftMenu(){
    const navigate = useNavigate();
    const HiddenTypography = styled(Typography)({
        display: 'none',
      });
      const logout = () => {}
    async function pinav(){
        navigate("/pi-list")

    }
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };
    const dispatch = useDispatch();

    const state = useSelector(state => state);

    async function kontraknav(){
        navigate("/Kontrak")

    }

    async function kontraksementara(){
        navigate("/KontrakTemp")
    }

    async function domisili(){
        navigate("/Domisili")
    }
    async function PaidInvoice(){
        navigate("/paid-invoice-list")
    }
    async function confrimsignature(){
        navigate("/confirmsignature")
    }
    async function domisilikokas(){
        navigate("/domisilikokas")
    }
    async function listinquiry(){
      navigate("/listinquiry")
    }
    async function listMail(){
      navigate("/listmail")
    }
    async function companyList(){
      navigate("/CompanyList")
    }
    console.log(state);

    return <Grid position="sticky" container justifyContent="center" alignItems="center">
        <Grid xs={12} container  justifyContent="center">
            <Typography align="center" className="left_menu" style={{overflowWrap: 'break-word'}} fullwidth>Zanio</Typography>
        </Grid>

        <>
        {state.user.role==="admin" && (
          <>
          <Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => navigate("/")}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Home">
    <div>
      <HomeIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
    </div>
  </Tooltip>
</Grid>

<Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => pinav()}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Proforma Invoice">
    <div>
      <ReceiptIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
    </div>
  </Tooltip>
</Grid>

<Grid
  xs={12}
  onClick={() => kontraknav()}
  sx={{ cursor: "pointer", mt: 3 }}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Kontrak">
    <div>
      <NoteAddIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
    </div>
  </Tooltip>
</Grid>

<Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => kontraksementara()}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Kontrak Sementara">
    <div>
      <HandshakeIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>

<Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => listMail()}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Surat/Paket">
    <div>
      <EmailIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>

<Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => navigate("/listnotifikasi")}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Notifikasi">
    <div>
      <NotificationsActiveIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>
<Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => domisili()}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Domisili">
    <div>
      <NotListedLocationIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>

<Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => domisilikokas()}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Domisili Kokas">
    <div>
      <FmdBadIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>

<Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => navigate("/calendar")}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Kalender">
    <div>
      <CalendarMonthIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
  

</Grid>
<Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3}}
  onClick={() => companyList()}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Company List">
    <div>
      <BusinessIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>
  <Grid 
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => navigate("/listKlien")}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Klien List">
    <div>
      <PersonAddIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color:"white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>
  <Grid 
  xs={12}
  sx={{ cursor: "pointer", mt: 3,  mb:20 }}
  onClick={() => navigate("/pulsamanagement")}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Pulsa Management List">
    <div>
      <AccountBalanceWalletIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color:"white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>
          </>
        )}
          </>

{/* //////////////////////////////////////////////////////////////////////////Sales View////////////////////////////////////////////////////////////////// */}
<>
        {state.user.role==="sales" && (
          <>
          <Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => navigate("/")}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Home">
    <div>
      <HomeIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
    </div>
  </Tooltip>
</Grid>


<Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => listinquiry()}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Inquiry">
    <div>
      <EmojiPeopleIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
  </Grid>
  <Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => pinav()}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Proforma Invoice">
    <div>
      <ReceiptIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
    </div>
  </Tooltip>
</Grid>

<Grid
  xs={12}
  onClick={() => kontraknav()}
  sx={{ cursor: "pointer", mt: 3 }}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Kontrak">
    <div>
      <NoteAddIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
    </div>
  </Tooltip>
</Grid>

<Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => kontraksementara()}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Kontrak Sementara">
    <div>
      <HandshakeIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>


<Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => domisili()}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Domisili">
    <div>
      <NotListedLocationIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>

<Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => domisilikokas()}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Domisili Kokas">
    <div>
      <FmdBadIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>

<Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => navigate("/calendar")}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Kalender">
    <div>
      <CalendarMonthIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>
<Grid item sx={{ display: 'flex', alignItems: 'center', textAlign: 'center', mt:3 }}>
        <Tooltip title="More">
        <IconButton
            onClick={handleClick}
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
          >
            <MoreHorizIcon sx={{ color: "white" }} />
          </IconButton>
        </Tooltip>
      </Grid>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 5,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'left', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
      >
        <MenuItem>
        <Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => navigate("/listKlien")}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Klien List">
    <div>
      <PersonAddIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>
        </MenuItem>
        <Divider />
        <MenuItem>
        <Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => companyList()}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Company List">
    <div>
      <BusinessIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>
<Grid 
  xs={12}
  sx={{ cursor: "pointer", mt: 3,  mb:20 }}
  onClick={() => navigate("/pulsamanagement")}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Pulsa Management List">
    <div>
      <AccountBalanceWalletIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color:"white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>
        </MenuItem>
      </Menu>
          </>
        )}
          </>

          {/* ////////////////////////////////////////////////////////////office Boy */}
          <>
        {state.user.role==="cleaning" && (
          <>
          <Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => navigate("/")}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Home">
    <div>
      <HomeIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
    </div>
  </Tooltip>
</Grid>




<Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => listMail()}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Surat/Paket">
    <div>
      <EmailIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>

<Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => navigate("/listnotifikasi")}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Notifikasi">
    <div>
      <NotificationsActiveIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>
<Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => domisilikokas()}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Domisili Kokas">
    <div>
      <FmdBadIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>

<Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => navigate("/calendar")}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Kalender">
    <div>
      <CalendarMonthIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>
          </>
        )}
          </>

{/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////Office Boy/////////////////////////////////////////////////// */}
 
 {/* /////////////////////////////////////////////////////////////////Finance */}
 <>
        {state.user.role==="finance" && (
          <>
          <Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => navigate("/")}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Home">
    <div>
      <HomeIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
    </div>
  </Tooltip>
</Grid>
          <Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => PaidInvoice()}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Paid Invoice">
    <div>
      <PaidIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>
        <Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => pinav()}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Proforma Invoice">
    <div>
      <ReceiptIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
    </div>
  </Tooltip>
</Grid>

<Grid
  xs={12}
  onClick={() => kontraknav()}
  sx={{ cursor: "pointer", mt: 3 }}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Kontrak">
    <div>
      <NoteAddIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
    </div>
  </Tooltip>
</Grid>

<Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => kontraksementara()}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Kontrak Sementara">
    <div>
      <HandshakeIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>
<Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => listMail()}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Surat/Paket">
    <div>
      <EmailIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>
<Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => companyList()}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Company List">
    <div>
      <BusinessIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>
<Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => navigate("/listKlien")}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Klien List">
    <div>
      <PersonAddIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>
<Grid 
  xs={12}
  sx={{ cursor: "pointer", mt: 3,  mb:20 }}
  onClick={() => navigate("/pulsamanagement")}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Pulsa Management List">
    <div>
      <AccountBalanceWalletIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color:"white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>
<Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => navigate("/calendar")}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Kalender">
    <div>
      <CalendarMonthIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>

</Grid>

</>)}</>
 
 
 
 
 
 
 
 
 
 
 
 
 
 
 
 
 
 {/* ///////////////////////////////////////////////////////Owner        */}
        
        <>
        {state.user.role==="owner" && (
          <>
          <Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => navigate("/")}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Home">
    <div>
      <HomeIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
    </div>
  </Tooltip>
</Grid>
<Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => navigate("/calendar")}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Kalender">
    <div>
      <CalendarMonthIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>

</Grid>
        <Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3}}
  onClick={() => pinav()}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Invoice">
    <div>
      <ReceiptIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
    </div>
  </Tooltip>
</Grid>

<Grid
  xs={12}
  onClick={() => kontraknav()}
  sx={{ cursor: "pointer", mt: 3 }}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Kontrak">
    <div>
      <NoteAddIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
    </div>
  </Tooltip>
</Grid>

<Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => kontraksementara()}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Kontrak Sementara">
    <div>
      <HandshakeIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>
<Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => domisili()}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Domisili">
    <div>
      <NotListedLocationIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>
<Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => PaidInvoice()}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Paid Invoice">
    <div>
      <PaidIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>
 
<Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => confrimsignature()}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Confirm Signature">
    <div>
      <VerifiedIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>

<Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => domisilikokas()}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Domisili Kokas">
    <div>
      <FmdBadIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>
<Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => listinquiry()}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Inquiry">
    <div>
      <EmojiPeopleIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>
<Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => listMail()}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Surat/Paket">
    <div>
      <EmailIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>
<Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3}}
  onClick={() => companyList()}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Company List">
    <div>
      <BusinessIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>
  <Grid 
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => navigate("/listKlien")}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Klien List">
    <div>
      <PersonAddIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color:"white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>
  <Grid 
  xs={12}
  sx={{ cursor: "pointer", mt: 3,  mb:20 }}
  onClick={() => navigate("/pulsamanagement")}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Pulsa Management List">
    <div>
      <AccountBalanceWalletIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color:"white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>
<Grid
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => navigate("/signup")}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="SignUp">
    <div>
      <VpnKeyIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color: "white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
    </div>
  </Tooltip>
</Grid>
 <Grid 
  xs={12}
  sx={{ cursor: "pointer", mt: 3 }}
  onClick={() => navigate("/SalesMeeting")}
  container
  justifyContent="center"
  alignItems="center"
>
  <Tooltip title="Sales Meeting">
    <div>
      <PersonAddIcon
        sx={{
          "&:hover": { color: "#bfb5b2" },
          mt: 0,
          mb: 0,
          color:"white",
          cursor: "pointer",
          fontSize: 30,
        }}
      />
      
    </div>
  </Tooltip>
</Grid>
</>)}</>
    </Grid>
}